import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GraphService {

  private graphApiUrl = 'https://graph.microsoft.com/v1.0/me/';
  //'https://graph.microsoft.com/v1.0/roleManagement/directory/roleEligibilityScheduleRequests/filterByCurrentUser(on="principal")';

  constructor(private http: HttpClient) {
    console.log("Graph")
  }

  // Get Microsoft Entra roles available for activation
  getAvailableRoles(): Observable<any> {
    const url = `${this.graphApiUrl}`;

    return this.http.get(url).pipe(
      map(response => {
        // Process the response as needed
        console.log('Available roles:', response);
        return response;
      })
    );
  }
}
